import { ApolloClient } from '@apollo/client';
import { FileDataType } from '../types';
import { returnArrayInBatch } from '../../../helpers/arrayHelpers';
import DELETE_SCRAP_DOCUMENT from '../../data/deleteScrapDocument';

export default async function deleteScrapDocumentsHandler(
  scrapId: number,
  client: ApolloClient<object>,
  filesList: Array<FileDataType>
) {
  try {
    //
    const batchListOfVariables = returnArrayInBatch(
      filesList.map((data, i) => {
        return {
          scrap_id: scrapId,
          document_id: data.id,
        };
      }),
      10
    );
    for (let batchListItem of batchListOfVariables) {
      // Start the process of saving uploaded file in scrap
      const responses = await Promise.all(
        batchListItem.map((variables) => {
          return client.mutate({
            mutation: DELETE_SCRAP_DOCUMENT(),
            variables,
          });
        })
      );
    }
  } catch (error) {
    //
  }
}
